import { render } from "./ShueishaOnlineApp.vue?vue&type=template&id=5dd69e7a&ts=true"
import script from "./ShueishaOnlineApp.vue?vue&type=script&lang=ts"
export * from "./ShueishaOnlineApp.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1028913207/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__